import { Component, effect, ElementRef, input, viewChild } from '@angular/core';
import lottie, { AnimationItem } from 'lottie-web';

@Component({
    selector: 'app-empty',
    standalone: true,
    imports: [],
    templateUrl: './empty.component.html',
    styleUrl: './empty.component.scss',
})
export class EmptyComponent {
    /** ViewChild for the lottie animation container */
    readonly lottieContainer = viewChild<ElementRef>('lottieContainer');

    /** The heading text to display. Defaults to 'No Records Found' */
    public title = input<string>('No Records Found');

    /** Optional subtitle/description text below the heading */
    public description = input<string>('');

    /** The lottie animation JSON file name (under assets/lottie-animations/). Defaults to 'No Items Found.json' */
    public animationName = input<string>('No Items Found.json');

    /** Whether to loop the lottie animation. Defaults to `true` */
    public loop = input<boolean>(true);

    /** The width of the animation container. Defaults to '200px' */
    public animationWidth = input<string>('200px');

    /** The height of the animation container. Defaults to '200px' */
    public animationHeight = input<string>('200px');

    private animationInstance: AnimationItem | null = null;

    constructor() {
        effect(() => {
            // track the input to re-run if animation name changes
            const name = this.animationName();
            const container = this.lottieContainer();

            if (container) {
                this.loadAnimation(name, container);
            }
        });
    }

    /**
     * Loads the lottie animation into the container
     */
    private loadAnimation(animationName: string, container: ElementRef): void {
        // Destroy previous instance if it exists
        if (this.animationInstance) {
            this.animationInstance.destroy();
            this.animationInstance = null;
        }

        const path = `assets/lottie-animations/${animationName}`;

        this.animationInstance = lottie.loadAnimation({
            container: container.nativeElement,
            renderer: 'svg',
            loop: this.loop(),
            autoplay: true,
            path,
        });
    }
}
